import PartnersList from '@/features/partners/PartnersList.tsx';

const InvestorPartnersPage = () => {
  return <PartnersList />;
};

export default InvestorPartnersPage;
